import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../../elements/Humberg';
import {  useSelector } from 'react-redux';
import LoaderBlock from '../../loader/LoaderBlock';
import SingleProduct from './SingleProduct';
import DateFilter from '../../../elements/DateFilter';

import TopBarValues from './topBarValues';
import Filters from './Filters';
import Loader from '../../loader/loader';
import SelectedProductButtons from './SelectedProductButtons';


const AllProducts = () => {





    const { loading,
        totalPages,
        products,
        totalProducts,
        totalorders,
        overallComission,
    } = useSelector((state) => state.Products)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: reservationLoading,  } = useSelector((state) => state.reservation)





    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [selectedProdcuts, setSelectedProdcuts] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");


    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("products")
        const subElement = document.getElementById("enabled-products");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        subElement?.classList.add("activeSubLink");

        document.title = `All Products `;

    }, []);
    // Remove one quantity


    return (
        <Fragment>
            {reservationLoading && <Loader />}
            <Humberg header="Products" headerLink="/products" children={"All Products"} />
            {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") &&
                <DateFilter
                    dateFrom={dateFrom}
                    setDateFrom={setDateFrom}
                    dateTo={dateTo}
                    setDateTo={setDateTo}
                />
            }
            <section className="p-[1.5vmax] mt-[1vmax]" >
                {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") &&
                    <TopBarValues totalProducts={totalProducts} totalorders={totalorders} overallComission={overallComission} />
                }
                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                {user?.role !== "PM" &&
                    <div className="bg-white flex justify-between items-center  px-[2vmax] pt-[2vmax] pb-[1vmax]">
                        <div className="flex-center">
                            <span className='flex-center' >Select All &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedProdcuts(products.map(r => r.id));
                                    } else {
                                        setSelectedProdcuts([]);
                                    }
                                }}
                            />
                        </div>
                        {selectedProdcuts?.length > 0 && (

                            <SelectedProductButtons selectedProdcuts={selectedProdcuts} setSelectedProdcuts={setSelectedProdcuts} user={user} />
                        )}
                    </div>
                }
                {successMessage &&

                    <div className="w-fit  bg-blue-100 relative z-[1] text-blue-500 flex gap-[1vmax] p-[0.3vmax_1vmax] text-[1vmax] font-bold mx-[2vmax]">
                        <span> Operation Successful {successMessage}</span>
                        <button onClick={() => setSuccessMessage("")} ><i className="fa-xmark fa-solid"></i></button>
                    </div>
                }
                <div className="bg-white p-[2vmax] lg:mt-[-2vmax]  shadow-1 rounded-b-lg overflow-x-auto my-scroll-2 my-scroll-3">

                    <div className="flex mt-[2vmax] bg-gray-50 py-[1vmax] items-center min-w-max font-bold text-gray-700 border-b-2 border-gray-200">
                        {user?.role !== "PM" &&
                            <div className="text-center w-[60px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Select
                            </div>
                        }
                        <div className="text-center w-[50px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            No.
                        </div>
                        {user?.role !== 'PMM' &&
                            <div className="text-center px-[0.5vmax] w-[80px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Seller
                            </div>
                        }
                        {user?.role !== 'PM' && (
                            <div className="text-center px-[0.5vmax] w-[120px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                                Chinese Seller
                            </div>
                        )}
                        <div className="text-center  px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Market
                        </div>
                        <div className="text-center px-[0.5vmax] w-[180px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Keywords
                        </div>
                        <div className="text-center px-[0.5vmax] w-[80px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Sale Limit
                        </div>
                        <div className="text-center px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Remaining
                        </div>
                        <div className="text-center px-[0.5vmax] w-[130px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Today Remaining
                        </div>
                        <div className="text-center px-[0.5vmax] w-[170px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Commission
                        </div>
                        <div className="text-center  px-[0.5vmax] w-[180px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Product Type
                        </div>
                        <div className="text-center px-[0.5vmax] w-[140px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Product ID
                        </div>
                        <div className="text-center px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Product Image
                        </div>
                        <div className="text-center px-[0.5vmax] w-[140px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Published
                        </div>
                        <div className="text-center px-[0.5vmax] w-[100px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Status
                        </div>
                        <div className="text-center px-[0.5vmax] w-[250px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.6vmax] lg:text-[0.8vmax] font-semibold" >
                            Actions
                        </div>



                    </div>
                    {loading ?
                        <LoaderBlock />
                        :
                        products?.length > 0 ?
                            products.map((product, index) =>
                                <SingleProduct key={product.id} product={product} index={index}
                                    totalProducts={totalProducts} user={user} page={page}
                                    selectedProdcuts={selectedProdcuts}
                                    setSelectedProdcuts={setSelectedProdcuts}
                                />)
                            :
                            <div className="text-center w-[350%] lg:w-[150%] text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                No data found
                            </div>
                    }

                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default AllProducts